import '../scss/jjp.scss';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

window.addEventListener('DOMContentLoaded', () => {

    gsap.registerPlugin(ScrollTrigger);

    const items = gsap.utils.toArray(".list-group__item");

    const formSection = document.getElementById("form");

    const vh = (coef) => window.innerHeight * (coef / 100);
    // const vw = (coef) => window.innerWidth * (coef / 100);

    items.forEach((item, index) => {
        ScrollTrigger.create({
            trigger: item,
            start: 'top ' + vh(60),
            end: 'bottom ' + vh(40),
            toggleClass: "active",
            markers: false,
            pin: false,
            id: `item-${index}`,
            // onEnter: () => {
            //     console.log("Enter");
            // },
            // onLeave: () => {
            //     console.log("Leave");
            // },
        });
    });

    window.addEventListener('message', function (e) {
        if (e.origin !== "https://go.smuckerawayfromhome.com") return;
        var data = e.data
        if (data === 'submitted') {
            if (formSection) {
                formSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                });
            }
        } else if (data.startsWith("scroll")) {
            const id = data.split("_")[1];
            console.log('scrollto', data, id);
            const target = document.getElementById(id);
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                });
            }
        }
    });
});